import * as React from 'react';
import { flow } from 'lodash';
import { Button, Modal } from 'react-bootstrap';
import UpdateEmailModalForm from './UpdateEmailModalForm';
import {actions as authActions, IAuthActions} from '../../../../services/auth/reducer';
import { reduxForm, submit} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {IAuthState} from '../../../../services/auth/models';
import {push} from 'react-router-redux';
import {actions as quoteActions} from '../../../../services/quote/reducer';

interface IUpdateEmailModalProps {
  auth: IAuthState;
  email: string;
  phone1: string;
  actions: {
    submit(name: string);
    push(path: string);
    auth: IAuthActions;
  };
  dispatch: any;
}

interface IUpdateEmailModalStates {
  isSaved: boolean;
  showModal: boolean;
  isSubmitting: boolean;
}

class UpdateEmailModal extends React.Component<IUpdateEmailModalProps, IUpdateEmailModalStates> {
  public state = {
    isSubmitting: false,
    isSaved: false,
    showModal: false,
  };

  private openModal = () => {
    const { dispatch, change } = this.props;
    dispatch(change('password', ''));
    this.setState({
      showModal: true,
    });
  }

  private handleSubmit = (values) => {
    const { actions } = this.props;

    this.setState({
      isSubmitting: true,
    });

    actions.auth.updateCustomerEmailAndTelephone(values).then((response) => {
      this.setState({
        isSaved: true,
        isSubmitting: false,
      });
    });
  }

  private handleCloseModal = () => {
    this.setState({
      showModal: false,
      isSaved: false,
      isSubmitting: false,
    });
  }

  public render() {
    const { email, phone1 } = this.props;
    const { showModal, isSaved, isSubmitting } = this.state;

    return (
      <>
        <Button
          className={'btn-secondary continue-btn pull-right'}
          onClick={this.openModal}
        >
            Update my details
        </Button>

        <Modal show={showModal} onHide={this.handleCloseModal} >
          <Modal.Header closeButton={true}>
            <Modal.Title>Update</Modal.Title>
          </Modal.Header>
          <UpdateEmailModalForm
            onSubmit={this.handleSubmit}
            initialValues={{ email, phone1 }}
            onCloseModal={this.handleCloseModal}
            isSaved={isSaved}
            isSubmitting={isSubmitting}
          />
        </Modal>
      </>
    );
  }
}

export default flow([
  reduxForm({
    form: 'customer2',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  connect(
    (state) => {
      return {
        auth: state.auth,
        quote: state.quote,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        submit: bindActionCreators(submit, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
        dispatch,
      },
    }),
  ),
])(UpdateEmailModal);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/UpdateEmailModal/index.tsx